import { Divider, SectionHeader } from '@/components/ui';
import BuildingStatusFilters from './BuildingStatusFilters';
import PriceFilter from './PriceFilter';
import BedroomFilter from './BedroomFilter';
import BathroomFilter from './BathroomFilter';
import ExpectedMoveInDateFilter from './ExpectedMoveInDateFilter';
import CompliancesFilter from './CompliancesFilter';
import { BuildingAmenitiesFilter, PoliciesFilter, UnitAmenitiesFilter } from './AmenitiesFilter';

export function AllFilters() {
  return (
    <div className="space-y-4">
      <div>
        <SectionHeader title="Special gems" className="-ml-2" />
        <BuildingStatusFilters filterType="isVerified" />
        <BuildingStatusFilters filterType="isTopRated" />
        <BuildingStatusFilters filterType="isRentStabilized" />
        <BuildingStatusFilters filterType="hasBuildingGoodCauseEviction" />
      </div>
      <div>
        <Divider />
      </div>
      <div className="space-y-2 pb-4">
        <SectionHeader title="Price range" className="-ml-2" />
        <PriceFilter className="px-2" />
      </div>
      <div>
        <Divider />
      </div>
      <div className="space-y-2 pb-4">
        <SectionHeader title="Bedrooms" className="-ml-2" />
        <BedroomFilter showLabel={false} className="px-2" />
      </div>
      <div>
        <Divider />
      </div>
      <div className="space-y-2 pb-4">
        <SectionHeader title="Bathrooms" className="-ml-2" />
        <BathroomFilter className="px-2" />
      </div>
      <div>
        <Divider />
      </div>
      <div className="space-y-2 pb-4">
        <SectionHeader title="Expected move-in" className="-ml-2" />
        <ExpectedMoveInDateFilter showLabel={false} className="px-2" />
      </div>
      <div>
        <Divider />
      </div>
      <div className="space-y-2 pb-4">
        <SectionHeader title="Apartment amenities" className="-ml-2" />
        <UnitAmenitiesFilter className="px-2" />
      </div>
      <div>
        <Divider />
      </div>
      <div className="space-y-2 pb-4">
        <SectionHeader title="Building amenities" className="-ml-2" />
        <BuildingAmenitiesFilter className="px-2" />
      </div>
      <div>
        <Divider />
      </div>
      <div className="space-y-2">
        <SectionHeader title="Policies" className="-ml-2" />
        <PoliciesFilter className="px-2" />
      </div>
      <div>
        <Divider />
      </div>
      <div className="space-y-2 pb-4">
        <SectionHeader title="NYC government data" className="-ml-2" />
        <CompliancesFilter />
      </div>
    </div>
  );
}
